var _style, _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarcusEvansLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215 75",
    style: {
      enableBackground: "new 0 0 215 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 215,
    height: 75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170,40.3V52h33.9V40h-18.8c-1.8,0-4,0-4-1.8c0-1.8,2.3-1.8,4-1.8h18.8V24.5h-18.8c-1.8,0-4,0-4-1.8 c0-1.8,2.3-1.8,4-1.8h18.8V9h-22.6c-6.5,0-12,2.7-12,8.7c0,3.9,2.2,6.3,6.4,7.7v0.3c-4.1,1.1-6.4,3.6-6.4,7.3c0,3.2,2.3,6.3,6,7.3 v0.4L170,40.3L170,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123,64.5c-0.1-1.2,0.3-3,2.1-3c1.8,0,1.9,1.9,1.9,3H123L123,64.5L123,64.5L123,64.5z M133.9,67.8v-0.9 c0-5.2-2.2-8.9-8.5-8.9c-6.5,0-10,2.6-10,7.7c0,5.3,3.5,8.3,10,8.3c2.7,0,5.2-0.3,7.3-0.9v-4c-1.2,0.6-3.2,1-5.3,1 c-2.3,0-4.2-0.4-4.3-2.4L133.9,67.8L133.9,67.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "144.6,58.3 142.6,68.4 142.5,68.4 140.5,58.3 132.5,58.3 137.3,73.7 147.4,73.7 152.3,58.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.5,63.1c1.6-0.7,3.5-1.3,5.4-1.3c1.9,0,4.1,0.2,4.1,2.2c-0.7-0.1-1.9-0.2-3-0.2c-3.9,0-8.3,0.9-8.3,5.7 c0,3.2,2.9,4.5,5.9,4.5c2.2,0,4.2-0.8,5.3-2.6h0.1v2.2h7.3v-9.3c0-5.6-5.4-6.4-9.9-6.4c-3,0-4.4,0.3-6.8,0.9V63.1L152.5,63.1 L152.5,63.1L152.5,63.1z M162,67.4c0,1.3-0.8,2.7-2.4,2.7c-1.2,0-1.8-0.4-1.8-1.5c0-1.6,1.9-1.7,3.5-1.7h0.8V67.4L162,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170,73.6h7.8v-8.8c0-0.9,0-2.1,1.4-2.1c1.4,0,1.4,1.2,1.4,2.1v8.8h7.8V63c0-3-1.5-5-5.7-5 c-2.2,0-4.3,0.9-5.3,3h-0.1v-2.7H170L170,73.6L170,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.5,73.1c2.2,0.5,4.5,0.9,6.8,0.9c3.7,0,9-1.2,9-5.6c0-5.8-9.1-3.9-9.1-5.5c0-0.9,1.4-1.1,2.7-1.1 c1.8,0,3.4,0.3,5.1,0.9v-4.1c-1.9-0.4-3.9-0.7-5.8-0.7c-3.8,0-9.1,0.8-9.1,5.2c0,5.9,9.1,4.1,9.1,6c0,0.8-1.6,1-2.9,1 c-2,0-4.2-0.5-5.7-1.4L189.5,73.1L189.5,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.1,73.6h7.8v-8.8c0-0.9,0-2.1,1.4-2.1c1.4,0,1.4,1.2,1.4,2.1v8.8h7.8v-8.8c0-0.9,0-2.1,1.4-2.1 c1.4,0,1.4,1.2,1.4,2.1v8.8H29v-9.2c0-3,0-6.5-5.7-6.5c-1.9,0-4.7,0.9-5.2,2.6h-0.1c-0.6-1.8-2.9-2.6-5.1-2.6c-2.5,0-4.6,0.9-5.5,3 H7.4v-2.7H0.1V73.6L0.1,73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,63.1c1.5-0.7,3.5-1.3,5.4-1.3c2,0,4.1,0.2,4.1,2.2c-0.7-0.1-2-0.2-3-0.2c-3.9,0-8.3,0.9-8.3,5.7 c0,3.2,2.9,4.5,5.9,4.5c2.2,0,4.2-0.8,5.3-2.6h0.1v2.2h7.3v-9.3c0-5.6-5.4-6.4-9.9-6.4c-3,0-4.4,0.3-6.8,0.9L31.5,63.1L31.5,63.1 L31.5,63.1L31.5,63.1z M41,67.4c0,1.3-0.8,2.7-2.4,2.7c-1.2,0-1.8-0.4-1.8-1.5c0-1.6,1.9-1.7,3.5-1.7H41V67.4L41,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.3,58.3v15.4h7.8v-5.6c0-2.3,1.8-4.1,4-4.1c0.7,0,1.4,0.1,1.8,0.2v-6.2c-0.3-0.1-0.8-0.2-1.3-0.2 c-2.4,0-4,1.7-4.9,3.8h-0.1v-3.5L49.3,58.3L49.3,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,68.7c-1.1,0.6-2.2,0.9-3.6,0.9c-2.3,0-3.9-1.4-3.9-3.8c0-2.3,1.6-3.4,3.9-3.4c1.4,0,2.5,0.3,3.5,0.8 v-4.5c-1.6-0.4-3.3-0.7-5.7-0.7c-6.6,0-10,2.6-10,7.8c0,5.3,3.5,8.3,10,8.3c2.3,0,4.1-0.2,5.8-0.8V68.7L78.7,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,58.3h-7.8v8.8c0,0.9,0,2.1-1.4,2.1c-1.4,0-1.4-1.2-1.4-2.1v-8.8h-7.8V69c0,3,1.5,5,5.7,5 c2.2,0,4.3-0.8,5.3-3h0.1v2.7h7.4L98.4,58.3L98.4,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.5,73.1c2.2,0.5,4.5,0.9,6.8,0.9c3.7,0,9-1.2,9-5.6c0-5.8-9.1-3.9-9.1-5.5c0-0.9,1.4-1.1,2.7-1.1 c1.8,0,3.4,0.3,5.1,0.9v-4.1c-1.9-0.4-3.9-0.7-5.8-0.7c-3.8,0-9.1,0.8-9.1,5.2c0,5.9,9.1,4.1,9.1,6c0,0.8-1.6,1-2.9,1 c-2,0-4.2-0.5-5.7-1.4L99.5,73.1L99.5,73.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.9,5c0,2.2,1.8,4,4,4s4-1.8,4-4s-1.8-4-4-4C208.7,1,206.9,2.8,206.9,5L206.9,5L206.9,5L206.9,5z M207.8,5 c0-1.9,1.4-3.4,3.2-3.4s3.2,1.4,3.2,3.4s-1.4,3.4-3.2,3.4C209.1,8.4,207.8,6.9,207.8,5L207.8,5L207.8,5L207.8,5z M209.4,2.7 c0,0.1,0,4.3,0,4.5c0.1,0,0.6,0,0.7,0c0-0.1,0-2,0-2h0.6c0.1,0,1.3,2,1.3,2s0.5,0,0.7,0c-0.1-0.2-1.2-2-1.2-2l0.1,0 c0.8-0.1,1.1-0.4,1.1-1.2c0-0.9-0.5-1.3-1.6-1.3C211.1,2.7,209.6,2.7,209.4,2.7L209.4,2.7L209.4,2.7L209.4,2.7z M210.1,4.6V3.2h0.9 c0.7,0,1,0.2,1,0.7c0,0.7-0.5,0.8-1,0.8L210.1,4.6L210.1,4.6L210.1,4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcusEvansLogo);
export default __webpack_public_path__ + "static/media/marcusEvansLogo.a4160d27958da35c14a68f1181d4b93c.svg";
export { ForwardRef as ReactComponent };